import { render } from "./BannerCards.vue?vue&type=template&id=326befac&scoped=true"
import script from "./BannerCards.vue?vue&type=script&lang=js"
export * from "./BannerCards.vue?vue&type=script&lang=js"

import "./BannerCards.vue?vue&type=style&index=0&id=326befac&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326befac"]])

export default __exports__